module.exports = __webpack_public_path__ + "img/caidaoApp-top.6ea3e5bc.png";